export const abilities = {
    ADMIN: 'admin-access',
    VIEW_CAST_MEMBERS: 'view-cast-members',
    VIEW_CAST_MEMBER_DATA: 'view-cast-member-data',
    VIEW_CHARACTERS: 'view-characters',
    EDIT_CAST_MEMBERS: 'edit-cast-members',
    EDIT_CHARACTERS: 'edit-characters',
    EDIT_LOOKUPS: 'edit-lookups',
    EDIT_SITE_SETTINGS: 'edit-site-settings'
};

const abilityConfig = {
    ADMIN: Object.values(abilities),
    CAST_VIEWER: [abilities.VIEW_CAST_MEMBERS],
    CAST_VIEW_DATA: [abilities.VIEW_CAST_MEMBER_DATA],
    CHARACTER_VIEWER: [abilities.VIEW_CHARACTERS],
    CAST_EDITOR: [abilities.EDIT_CAST_MEMBERS],
    CHARACTER_EDITOR: [abilities.EDIT_CHARACTERS],
    LOOKUPS_EDITOR: [abilities.EDIT_LOOKUPS],
    SITE_SETTINGS_EDITOR: [abilities.EDIT_SITE_SETTINGS],
};

export const ACCESS = {
    PAGE: abilityConfig,
    CTA: abilityConfig
};
